<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lPfNV3/tc-custom/9781641085892.jpg?1722379429523" alt="This image is the cover for the book Elf Shot, Monster Dads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elf Shot, Monster Dads
      </h1>
      <p class="bookDescription body article font2">
        <b>Special Illustrated Edition</b><br/><br/>  All Conri wanted was to drop his kid off at Changeling camp, find the nearest halfway nice hotel, and enjoy a week of uncomplicated debauchery. It should be simple. It doesn’t work out that way. When a local girl disappears, the neighborhood quickly lays blame at the well-guarded gates of the camp. With his son incriminated, a mystery to solve, and a malevolent pocket of the Otherworld to navigate, Conri will need all the help he can get—even if it does come from a distractingly pretty, tightly wound Iron Door agent who doesn’t trust Conri to be on the right side.  <br/><br/><i>Previously released as part of the anthology Bad, Dad, and Dangerous by Dreamspinner Press, October 2020</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        TA Moore, Emily Y Chan
      </h2>
      
      <p class="authorDescription body article"><P>TA Moore is a Northern Irish writer of romantic suspense, urban fantasy, and contemporary romance novels. A childhood in a rural seaside town fostered a suspicious nature, a love of mystery, and a streak of black humour a mile wide. As her grandmother always said, &ldquo;She&rsquo;d laugh at a bad thing, that one,&rdquo; mind you, that was the pot calling the kettle black. TA studied history, Irish mythology, and English at University, mostly because she has always loved a good story. She has worked as a journalist, a finance manager, and in the arts sectors before she finally gave in to a lifelong desire to write.</P><P>Coffee, Doc Marten boots, and good friends are the essential things in life. Spiders, mayo, and heels are to be avoided.</P><P>Website: www.nevertobetold.co.uk</P><P>Facebook: www.facebook.com/TA.Moores</P><P>Twitter: @tammy_moore</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dec377f4